<template>
  <div>
    <base-engagement-tool
      :pageHeadingInfo="pageHeadingInfo"
      :linkGoalInfo="linkGoalInfo"
      :leftToolSummary="leftToolSummary"
      :isShowEmptyState="isShowEmptyState"
      :isShowDownloadIcon="true"
      :emptyChartMessage="emptyChartMessage"
      :rightToolSummary="rightToolSummary"
      :formModel="formModel"
      :chartTabContent="chartTabContentGraph"
      :chartProperties="chartProperties"
      :chartData="chartGraphData"
      :downloadOption="reportDownloadOption"
      downloadLabelName="Report"
      :selectedComponent="selectedComponent"
      :secondSelectData="secondSelectData"
      :firstSelectData="firstSelectData"
      :firstOptionLabel="firstOptionLabel"
      :secondOptionLabel="secondOptionLabel"
      :projectionYear="projectionYear"
      imageheight="45"
      imagewidth="45"
      :cardData="cardData"
      @submit="applyFilter"
      @refresh="refreshOutstandingBalance"
      @reset="resetForm"
      @cancelInstance="cancelInstance"
      @saveInstance="saveInstance"
      @onBack="onBack"
      @changeLoanInfo="changeInvestmentInfo"
      @linkClick="genericMethodClick"
      @changeProjectionYear="changeProjectionYear"
      @onChangeChartTab="onChangeChartTab"
      @formChange="formChange"
      @dropDownChange="genericMethodClick"
      @EditAdditionalform="EditAdditionalform"
      @downloadExcelFile="downloadReport"
      :showTableView="showTableView"
      :tableViewSettings="tableViewSettings"
      :buttonDataTypeConfig="buttonDataTypeConfig"
      :buttonViewTypeConfig="buttonViewTypeConfig"
      @onSelectDataTypeFilter="onSelectDataTypeFilter"
      @onSelectViewTypeFilter="onSelectViewTypeFilter"
    ></base-engagement-tool>

    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="genericMethodClick"
    ></confirmation-dialog>

    <component
      :is="selectedAdvanceFilterComponent"
      :isopenModel="isopenModel"
      :baselineData="baselineData"
      :openTabName="openTabName"
      @closeModel="closeModel"
      @saveData="resetInvestmentModel"
      v-if="selectedAdvanceFilterComponent != null"
      :tableViewSettings="tableViewSettings"
      :showTableView="GraphViewType == 3"
    >
    </component>
  </div>
</template>

<script>
import { BaseEngagementTool } from "../../component/loan";
import { ConfirmationDialog } from "../../component/tool";
import { CommonHelper } from "../../helpers";
import {
  RepaymentOptionList,
  AdvanceInvestmentFilter,
  AdvanceFilterInvestmentComponetName,
  InvestmentClass,
  DownloadOption,
  tableBalanceAreaInvestment,
} from "../../helpers/constant";
import Investment from "../../models/investment";
import InvestmentAdvanceFilter from "./investment-advance-filter.vue";
import InvestmentProjection from "../../models/investmentProjection";
import {
  InvestmentEngagementTool,
  EngagementBasicScreen,
  ICEInvestmentIntegration,
  UserEvent,
  ExcelDownload,
} from "../../mixin";

import { InvestmentService } from "../../services";
import {
  GET_SELECTED_INVESTMENT_INFORMATION,
  GET_INVESTMENT_ENTITY_INFORMATION,
  GET_INVESTMENT_TYPE_INFORMATION,
  GET_INVESTMENT_INFORMATION,
  SET_NOTIFICATION_SUMMARY,
  SET_PROJECTION_MODEL,
  SET_PROJECTION_API_RESPONSE,
  GET_PROJECTION_MODEL,
  SET_INVESTMENT_CHART_MODEL,
  SET_SELECTED_INVESTMENT_INFORMATION,
  GET_RISK_PROFILE_DATA,
  SET_LOADER_VISIBILITY,
  GET_INVESTMENT_CHART_MODEL,
} from "../../helpers/vuex-constants";
import { mapGetters, mapActions } from "vuex";
import {
  InvestmentSelected,
  UpdateAction,
  AdvaceGraphAction,
  SaveAction,
  DownloadExcelFile,
  DownloadPDFFile,
  DownloadWordFile,
} from "../../helpers/userEvent";

export default {
  components: {
    BaseEngagementTool,
    ConfirmationDialog,
    InvestmentAdvanceFilter,
  },
  data() {
    return {
      baselineData: "",
      selectedAdvanceFilterComponent: "",
      reportDownloadOption: DownloadOption,
      openTabName: "",
      refreshKey: 0,
      isopenModel: false,

      lastprojectionYear: 0,
      isShowEmptyState: false,
      pageHeadingInfo: {
        heading: "Enter and test investment details",
        headingIconText: " test hover",
        subHeading:
          "You can keep adjusting until you are happy with the outcome",
      },

      projectionModel: {},
      tableViewSettings: {},
      showTableView: false,
      buttonDataTypeConfig: [],
      buttonViewTypeConfig: [],
    };
  },
  mounted() {
    this.projectionYear.Value = this.selectedInvestmentData.projectionYear;
    if (
      this.selectedInvestmentData.investmentGuid !=
        "00000000-0000-0000-0000-000000000000" ||
      this.selectedInvestmentData.isNotShowEmptyState
    ) {
      this.applyFilter();
    } else {
      this.isShowEmptyState = true;
    }
    this.formChange(this.formModel);

    this.setAddtionFilterInfoInFormModel();
  },

  async created() {
    this.setChartViewTypeDropDown();
  },

  computed: {
    GraphViewType() {
      return this.currentGraphView;
    },
    chartTabContentGraph() {
      if (this.showTableView) {
        return this.chartTabContentTableView;
      } else {
        return this.chartTabContent;
      }
    },
    cardData() {
      return {
        description: this.selectedInvestmentData.description,
        imagepath: require(`../../assets/icons/investments.svg`),
      };
    },

    firstOptionLabel() {
      this.refreshKey;
      let selectedOwner = this.firstSelectData.filter(
        (sr) => sr.value == this.selectedInvestmentData.ownerId
      );

      return {
        value: this.selectedInvestmentData.ownerId,
        text:
          selectedOwner.length > 0
            ? selectedOwner[0].text.replace(/(^MRS|MR|MISS)/gi, "")
            : "",
      };
    },
    secondOptionLabel() {
      this.refreshKey;
      let selectedInvestmentType = this.secondSelectData.filter(
        (sr) => sr.value == this.selectedInvestmentData.investmentClassID
      );
      return {
        value: this.selectedInvestmentData.investmentClassID,
        text:
          selectedInvestmentType.length > 0
            ? selectedInvestmentType[0].text
            : InvestmentClass.OTH,
      };
    },
    formModel() {
      let userSelectedLoan = this.getInvestmentInformation.filter(
        (sr) => sr.investmentGuid == this.selectedInvestmentData.investmentGuid
      );

      return {
        type: "Form",
        groupFormat: [
          { name: "", element: [0], class: "" },
          { name: "RETURN", element: [1, 2, 3, 4, 5], class: "group-section" },
          {
            name: "Contribution",
            element: [6, 7, 8, 9],
            class: "group-section",
          },
          { name: "", element: [10, 11, 12], class: "" },
        ],
        elements: [
          {
            type: "FormField",
            id: "367",
            name: "Initial Balance",
            dataType: "text",
            displayType: "slider",
            htmlName: "initialbalance",
            options: [],
            defaultValue:
              userSelectedLoan.length > 0 ? userSelectedLoan[0].amount : 0,
            value: this.selectedInvestmentData.amount,
            lastUserEnteredValue: this.selectedInvestmentData.Amount,
            minValue: 0,
            maxValue: 2000000,
            inputMax: 999999999,
            step: 10000,
            inputFormat: "$,",
            isShowRefreshIcon:
              this.selectedInvestmentData.isExisting &&
              this.selectedInvestmentData.factInvestmentAmount !=
                this.selectedInvestmentData.amount
                ? true
                : false,
            originalValue: this.selectedInvestmentData.factInvestmentAmount,
            tooltipMessage: "Import latest balance from FactFind",
            refreshText: "Use latest balance",
            ischeckRefreshIcon: this.selectedInvestmentData.isExisting,
            isCurrencyFormat: true,
            maxlength: 9,
          },
          {
            type: "FormField",
            id: "368",
            name: "Risk Profile",
            dataType: "text",
            displayType: "singleSelect",
            htmlName: "riskProfile",
            options: this.getRiskProfileData.data,
            defaultValue: userSelectedLoan[0].riskProfileId,
            lastUserEnteredValue: userSelectedLoan[0].riskProfileId,
            value: this.selectedInvestmentData.riskProfileId,
            emitevent: "onChangeRiskProfile",
            validations: [],
          },
          {
            type: "FormField",
            id: "369",
            name: "Income",
            dataType: "text",
            displayType: "slider",
            htmlName: "incomeRate",
            step: 0.25,
            options: [],
            defaultValue: userSelectedLoan[0].incomeRate,
            value: this.selectedInvestmentData.incomeRate,
            lastUserEnteredValue: this.selectedInvestmentData.incomeRate,
            minValue: 0,
            isShowDecimal: true,
            maxValue: 15,
            inputMax: 99.99,
            validations: [],
            inputFormat: "%",
            maxlength: 5,
          },
          {
            type: "FormField",
            id: "370",
            name: "Growth",
            dataType: "text",
            displayType: "slider",
            htmlName: "growthRate",
            step: 0.25,
            options: [],
            isShowDecimal: true,
            defaultValue: userSelectedLoan[0].growthRate,
            value: this.selectedInvestmentData.growthRate,
            lastUserEnteredValue: this.selectedInvestmentData.growthRate,
            minValue: 0,
            maxValue: 15,
            inputMax: 99.99,
            validations: [],
            inputFormat: "%",
            maxlength: 5,
          },

          {
            type: "FormField",
            id: "371",
            name: "Franking",
            dataType: "text",
            displayType: "slider",
            htmlName: "frankingRate",
            isShowDecimal: true,
            step: 5,
            options: [],
            defaultValue: userSelectedLoan[0].frankingRate,
            value: this.selectedInvestmentData.frankingRate,
            lastUserEnteredValue: this.selectedInvestmentData.frankingRate,
            minValue: 0,
            maxValue: 100,
            inputMax: 99,
            validations: [],
            inputFormat: "%",
            maxlength: 5,
          },
          {
            type: "FormField",
            id: "372",
            name: "Adjustment",
            dataType: "text",
            displayType: "AdditionalInformation",
            htmlName: "AdditionalFieldReturn",
            options: [],
            defaultValue: 0,
            value: 0,
            validations: [],
            inputFormat: "%",
          },
          {
            type: "FormField",
            id: "373",
            name: "Contribution",
            dataType: "text",
            displayType: "slider",
            htmlName: "contributionAmount",
            options: [],
            defaultValue: userSelectedLoan[0].contributionAmount,
            value: this.selectedInvestmentData.contributionAmount,
            lastUserEnteredValue:
              this.selectedInvestmentData.contributionAmount,
            minValue: 0,
            maxValue: 5000,
            inputMax: 999999999,
            step: 100,
            validations: [],
            inputFormat: "$,",
            isCurrencyFormat: true,
            maxlength: 9,
          },
          {
            type: "FormField",
            id: "374",
            name: "Contribution Frequency",
            dataType: "text",
            displayType: "singleSelect",
            htmlName: "durationType",
            options: RepaymentOptionList,
            defaultValue: userSelectedLoan[0].durationTypeId,
            value: this.selectedInvestmentData.durationTypeId,
            lastUserEnteredValue: this.selectedInvestmentData.durationTypeId,
            validations: [],
          },
          {
            type: "FormField",
            id: "375",
            name: "Dividend Reinvestment",
            label: "Dividend Reinvestment",
            dataType: "text",
            displayType: "switch",
            htmlName: "DRP",
            options: [],
            defaultValue: userSelectedLoan[0].isDRP,
            value: this.selectedInvestmentData.isDRP,
            lastUserEnteredValue: this.selectedInvestmentData.isDRP,
            validations: [],
          },
          {
            type: "FormField",
            id: "376",
            name: "Adjustment",
            dataType: "text",
            displayType: "AdditionalInformation",
            htmlName: "AdditionalFieldContribution",
            options: [],
            defaultValue: 0,
            value: 0,
            validations: [],
            inputFormat: "%",
          },
          {
            type: "FormField",
            id: "377",
            name: "Update",
            style: "",
            dataType: "submit",
            displayType: "submit",
            htmlName: "submit",
            validations: [],
          },
          {
            type: "FormField",
            id: "378",
            name: "Reset",
            style: '{"margin-left":"20px"}',
            dataType: "text",
            displayType: "reset",
            htmlName: "submit",
            isdisabled: true,
            validations: [],
          },
          {
            type: "FormField",
            id: "379",
            name: "Advanced",
            style: '{"margin-left":"20px"}',
            dataType: "text",
            displayType: "link",
            method: "openAdvancedFilter",
            htmlName: "link",
            isdisabled: true,
            validations: [],
          },
        ],
        htmlName: "LoanBasicFilter",
        isResponsive: "true",
        size: {
          type: "Size",
          width: "0",
          height: "0",
        },
      };
    },
    ...mapGetters({
      getRiskProfileData: GET_RISK_PROFILE_DATA,
    }),
    ...mapGetters("investment", {
      selectedInvestmentData: GET_SELECTED_INVESTMENT_INFORMATION,
      firstSelectData: GET_INVESTMENT_ENTITY_INFORMATION,
      secondSelectData: GET_INVESTMENT_TYPE_INFORMATION,
      advanceScreenInvestmentChartModel: GET_INVESTMENT_CHART_MODEL,
      getInvestmentInformation: GET_INVESTMENT_INFORMATION,
      getProjectionModel: GET_PROJECTION_MODEL,
    }),
  },
  mixins: [
    InvestmentEngagementTool,
    ICEInvestmentIntegration,
    EngagementBasicScreen,
    UserEvent,
    ExcelDownload,
  ],

  methods: {
    onSelectViewTypeFilter(button, data) {
      button.toggle2 = false;
      this.buttonViewTypeConfig[0].listItems.forEach(
        (m) => (m.isActive = false)
      );
      data.isActive = true;
      button.text = "View: " + data.itemText.slice(0, -5);
      this.showTableView = data.itemValue == 3;
      this.currentGraphView = data.itemValue;
    },
    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    ...mapActions("investment", {
      setProjectionApiResponse: SET_PROJECTION_API_RESPONSE,
      setInvestmentChartModel: SET_INVESTMENT_CHART_MODEL,
      setSelectedInvestmentInfo: SET_SELECTED_INVESTMENT_INFORMATION,
      setProjectionModel: SET_PROJECTION_MODEL,
    }),
    onLeave(event) {
      let isFormChanges = this.formModel.elements.findIndex(
        (sr) => sr.defaultValue != sr.value
      );
      if (isFormChanges >= 0) {
        event.preventDefault();
        event.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page? Unsaved changes will be lost.";
      }
    },
    refreshOutstandingBalance() {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) => sr.htmlName == "initialbalance"
      );
      if (elementIndex >= 0) {
        this.formModel.elements[elementIndex].isShowRefreshIcon = false;
        this.formModel.elements[elementIndex].value =
          this.formModel.elements[elementIndex].originalValue;
        this.enableResetButton(true);
      }
    },
    EditAdditionalform(data) {
      if (data.typeId == AdvanceInvestmentFilter.Return) {
        this.openTabName = AdvanceFilterInvestmentComponetName.Return;
      } else if (data.typeId == AdvanceInvestmentFilter.Contribution) {
        this.openTabName = AdvanceFilterInvestmentComponetName.Contribution;
      } else if (data.typeId == AdvanceInvestmentFilter.Withdrawal) {
        this.openTabName = AdvanceFilterInvestmentComponetName.Withdrawal;
      } else if (data.typeId == AdvanceInvestmentFilter.Fee) {
        this.openTabName = AdvanceFilterInvestmentComponetName.Fee;
      } else if (data.typeId == AdvanceInvestmentFilter.Maturity) {
        this.openTabName = AdvanceFilterInvestmentComponetName.Maturity;
      } else if (data.typeId == AdvanceInvestmentFilter.MarketCrash) {
        this.openTabName = AdvanceFilterInvestmentComponetName.MarketCrash;
      }
      this.openAdvancedFilter();
    },
    genericMethodClick(function_name, data) {
      this[function_name](data);
    },
    onChangeRiskProfile(data) {
      this.setFormProperties("riskProfile", data.value, "value");
      this.setFormProperties("frankingRate", data.frankingRate, "value");
      this.setFormProperties("growthRate", data.growthRate, "value");
      this.setFormProperties("incomeRate", data.incomeRate, "value");
    },
    setFormProperties(key, value, fieldName) {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) => sr.htmlName == key
      );
      if (elementIndex >= 0) {
        this.formModel.elements[elementIndex][fieldName] = value;
      }
    },
    getFormProperties(key) {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) => sr.htmlName == key
      );
      if (elementIndex >= 0) {
        return this.formModel.elements[elementIndex]["value"];
      }
    },
    cancelInstance() {
      this.confirmationDialogList[2].toggle = true;
    },
    saveInstance() {
      if (!this.validationsProjectionYear()) {
        return false;
      }

      if (
        this.selectedInvestmentData.investmentGuid ==
        "00000000-0000-0000-0000-000000000000"
      ) {
        this.saveButtonDialogSaveAs_Click();
      } else {
        this.confirmationDialogList[1].toggle = true;
      }
    },
    onBack() {
      let resetButtonIndex = this.formModel.elements.findIndex(
        (sr) => sr.displayType == "reset"
      );
      if (resetButtonIndex >= 0) {
        if (this.formModel.elements[resetButtonIndex].isdisabled) {
          this.$router.push({ name: "investment-instance-selection" });
        } else {
          this.confirmationDialogList[0].toggle = true;
        }
      }
    },

    backButtonDialogDiscard_Click() {
      this.$router.push({ name: "investment-instance-selection" });
    },
    cancelButtonDialogDiscard_Click() {
      this.$router.push({ name: "engagement-tool-selection" });
    },
    backButtonDialogCancel_Click() {},
    backButtonDialogSave_Click() {
      this.confirmationDialogList.forEach((item) => {
        item.toggle = false;
      });
      this.confirmationDialogList[1].toggle = true;
    },

    saveButtonDialogCancel_Click() {},

    async saveButtonDialogSave_Click() {
      let isNeedTocallProjectionApi = this.IsNeedtoCallProjectionAPI();
      let isUpdate = 0;
      let resetButtonIndex = this.formModel.elements.findIndex(
        (sr) => sr.displayType == "reset"
      );
      if (resetButtonIndex >= 0) {
        if (this.formModel.elements[resetButtonIndex].isdisabled) {
          isUpdate = 0;
        } else {
          isUpdate = 1;
        }
      }
      if (isNeedTocallProjectionApi) {
        await this.applyFilter();
      }
      let investmentUIModel = Investment.CreateInvestmentModel(
        this.formModel,
        this.selectedInvestmentData
      );
      this.selectedInvestmentData.projectionYear = this.projectionYear.Value;
      let investmentModel = this.createSaveInvestmentModel(
        investmentUIModel,
        this.selectedInvestmentData
      );
      let projectionModel = this.getProjectionModel;

      this.setLoaderVisibility(true);
      var apiResponse = await InvestmentService.saveInvestmentInformation(
        investmentModel,
        projectionModel
      );
      this.setLoaderVisibility(false);
      this.saveUserSession(
        InvestmentSelected,
        SaveAction,
        investmentModel.investmentClassID
      );
      this.saveInvestmentData(
        apiResponse,
        this.selectedInvestmentData,
        isUpdate
      );
    },
    async saveButtonDialogSaveAs_Click() {
      let isNeedTocallProjectionApi = this.IsNeedtoCallProjectionAPI();
      if (isNeedTocallProjectionApi) {
        await this.applyFilter();
      }
      this.setProjectionApiResponse({});
      this.setInvestmentChartModel(this.projectionModel);

      let investmentUIModel = Investment.CreateInvestmentModel(
        this.formModel,
        this.selectedInvestmentData
      );

      let investmentModel = this.createSaveInvestmentModel(
        investmentUIModel,
        this.selectedInvestmentData
      );
      investmentModel.projectionYear = this.projectionYear.Value;

      investmentModel.factInvestmentAmount =
        this.selectedInvestmentData.factInvestmentAmount;

      this.setSelectedInvestmentInfo(investmentModel);
      this.$router.push({ name: "save-investment-engagement-tool" });
    },
    enableResetButton(isFormChanges) {
      let resetButtomIndex = this.formModel.elements.findIndex(
        (sr) => sr.displayType == "reset"
      );
      if (resetButtomIndex >= 0) {
        if (isFormChanges) {
          this.formModel.elements[resetButtomIndex].isdisabled = false;
        } else {
          this.formModel.elements[resetButtomIndex].isdisabled = true;
        }
      }
    },

    closeModel() {
      this.isopenModel = false;
      this.selectedAdvanceFilterComponent = "";
      this.setInvestmentChartModel({});
      this.applyFilter();
    },

    changeInvestmentInfo(data) {
      if (data && data.option1 && data.option1.value) {
        this.selectedInvestmentData.ownerId = data.option1.value;
        this.selectedInvestmentData.ownerEntityType = data.option1.entityType;
      }
      if (data && data.option2 && data.option2.value) {
        this.selectedInvestmentData.investmentClassID = data.option2.value;
      }
      this.formChange(this.formModel);
    },
    resetUserInvestmentInfo() {
      let userSelectedLoan = this.getInvestmentInformation.filter(
        (sr) => sr.investmentGuid == this.selectedInvestmentData.investmentGuid
      );
      if (userSelectedLoan && userSelectedLoan.length > 0) {
        this.selectedInvestmentData.investmentClassID =
          userSelectedLoan[0].investmentClassID;
        this.selectedInvestmentData.ownerId = userSelectedLoan[0].ownerId;
      }
    },
    resetForm() {
      let totalFields = this.formModel.elements.length;
      for (let i = 0; i < totalFields; i++) {
        this.formModel.elements[i].value =
          this.formModel.elements[i].defaultValue;
      }
      this.resetUserInvestmentInfo();
      this.enableResetButton(false);

      this.refreshKey++;
      this.enableOutStandingRefreshIcon();
    },
    enableOutStandingRefreshIcon() {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) => sr.htmlName == "initialbalance"
      );
      if (elementIndex >= 0) {
        if (
          this.formModel.elements[elementIndex].ischeckRefreshIcon &&
          this.formModel.elements[elementIndex].originalValue !=
            this.formModel.elements[elementIndex].value
        ) {
          this.formModel.elements[elementIndex].isShowRefreshIcon = true;
        }
      }
    },

    isUserLoanInfoChange() {
      let userSelectedInvestment = this.getInvestmentInformation.filter(
        (sr) => sr.investmentGuid == this.selectedInvestmentData.investmentGuid
      );
      if (userSelectedInvestment && userSelectedInvestment.length > 0) {
        if (
          this.selectedInvestmentData.investmentClassID !=
            userSelectedInvestment[0].investmentClassID ||
          this.selectedInvestmentData.ownerId !=
            userSelectedInvestment[0].ownerId
        ) {
          this.enableResetButton(true);
        } else {
          this.enableResetButton(false);
        }
      }
    },

    formChange() {
      let isFormChanges = this.formModel.elements.findIndex(
        (sr) => sr.defaultValue != sr.value
      );
      if (isFormChanges >= 0) {
        this.enableResetButton(true);
      } else {
        this.isUserLoanInfoChange();
      }
      this.resetRiskProfileId();
      this.enableOutStandingRefreshIcon();
    },
    resetInvestmentModel(baselineModel) {
      this.setFormProperties(
        "frankingRate",
        baselineModel.frankingRate,
        "value"
      );
      this.setFormProperties("growthRate", baselineModel.growthRate, "value");
      this.setFormProperties("incomeRate", baselineModel.incomeRate, "value");
      this.setFormProperties(
        "contributionAmount",
        baselineModel.contributionAmount,
        "value"
      );
      this.setFormProperties(
        "durationType",
        baselineModel.durationTypeId,
        "value"
      );
      this.selectedInvestmentData.advancedetails = baselineModel.advancedetails;
      this.selectedInvestmentData.maturityDate = baselineModel.maturityDate;
      this.selectedInvestmentData.isRenewAuto = baselineModel.isRenewAuto;
      this.resetRiskProfileId();
      this.projectionModel = this.advanceScreenInvestmentChartModel;
      this.isShowEmptyState = false;
      this.setAddtionFilterInfoInFormModel();

      this.closeModel();
    },
    AdvancedFilterData(advanceFilterSetting) {
      if (!advanceFilterSetting || advanceFilterSetting.length == 0) {
        return [];
      }
      let advancedata = advanceFilterSetting.map((r) => {
        let p = {
          label: null,
          typeId: null,
          data: [],
        };

        let startMonth =
          !r.startDate || r.startDate == ""
            ? r.startDate
            : CommonHelper.getMonthName(
                CommonHelper.getMonthfromMonthYear(r.startDate)
              );
        let startYear =
          !r.startDate || r.startDate == ""
            ? r.startDate
            : CommonHelper.getYearfromMonthYear(r.startDate);
        let endMonth =
          !r.endDate || r.endDate == ""
            ? r.endDate
            : CommonHelper.getMonthName(
                CommonHelper.getMonthfromMonthYear(r.endDate)
              );
        let endYear =
          !r.endDate || r.endDate == ""
            ? r.endDate
            : CommonHelper.getYearfromMonthYear(r.endDate);
        p.typeId = r.typeId;
        if (
          r.description != undefined &&
          r.description != null &&
          r.description != ""
        ) {
          p.label = r.description;
        } else {
          p.label = this.DescriptionAdditionalForm(
            r.descriptionplaceholder,
            r.typeId
          );
        }
        if (r.typeId == 1) {
          p.data[0] = `Income ${CommonHelper.convertAmountIntoDecimalFormat(
            r.amount
          )}% Growth  ${CommonHelper.convertAmountIntoDecimalFormat(
            r.amount1
          )}% Franking ${CommonHelper.convertAmountIntoDecimalFormat(
            r.amount2
          )}%`;
        } else if (r.typeId == 2 || r.typeId == 3) {
          p.data[0] = `${CommonHelper.convertIntoCurrencyWithoutDecimal(
            r.amount
          )}`;
        } else if (r.typeId == 5) {
          p.data[0] = r.amount + "%";
        }
        if (r.typeId != 4)
          p.data[1] = `${startMonth}
            ${startYear}  ${endMonth ? "-" : ""} ${endMonth}
            ${endYear}`;
        if (r.typeId == 7) {
          if (r.option1 - 0 == 1 || r.option1 - 0 == 3)
            p.data[0] = r.amount + "%";
          else
            p.data[0] = `${CommonHelper.convertIntoCurrencyWithoutDecimal(
              r.amount1
            )}`;
        }
        return p;
      });
      return advancedata;
    },
    setAddtionFilterInfoInFormModel() {
      let additionalFilter = this.AdvancedFilterData(
        this.selectedInvestmentData.advancedetails
      );
      if (additionalFilter && additionalFilter.length > 0) {
        this.setFormProperties(
          "AdditionalFieldReturn",
          additionalFilter.filter(
            (sr) => sr.typeId == AdvanceInvestmentFilter.Return
          ),
          "options"
        );
        this.setFormProperties(
          "AdditionalFieldContribution",
          additionalFilter.filter(
            (sr) => sr.typeId != AdvanceInvestmentFilter.Return
          ),
          "options"
        );
      } else {
        this.setFormProperties("AdditionalFieldReturn", [], "options");
        this.setFormProperties("AdditionalFieldContribution", [], "options");
      }
    },
    resetRiskProfileId() {
      let currentIncomeRate = this.getFormProperties("incomeRate");
      let currentGrowthRate = this.getFormProperties("growthRate");
      let currentFrankingRate = this.getFormProperties("frankingRate");
      let riskProfileId = this.getFormProperties("riskProfile");

      let currentRiskProfile = this.getRiskProfileData.data.filter(
        (sr) => sr.value == riskProfileId
      );
      if (
        currentRiskProfile.length > 0 &&
        (currentRiskProfile[0].incomeRate != currentIncomeRate ||
          currentRiskProfile[0].growthRate != currentGrowthRate ||
          currentRiskProfile[0].frankingRate != currentFrankingRate)
      ) {
        this.setFormProperties("riskProfile", 0, "value");
      }
    },

    IsNeedtoCallProjectionAPI() {
      let userInputs = this.formModel.elements.filter(
        (sr) => sr.htmlName != "submit"
      );

      if (userInputs && userInputs.length > 0) {
        let userChangedFields = userInputs.filter(
          (sr) => sr.lastUserEnteredValue != sr.value
        );
        if (
          this.lastprojectionYear != this.projectionYear.Value ||
          (userChangedFields && userChangedFields.length > 0)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    getEloquaFormModel() {
      let currentInvestmentInfo = Investment.CreateInvestmentModel(
        this.formModel,
        {}
      );

      return {
        ownerEntityType: this.selectedInvestmentData.ownerEntityType,
        investmentClassID: this.selectedInvestmentData.investmentClassID,
        amount: currentInvestmentInfo.amount,
        riskProfileId: currentInvestmentInfo.riskProfileId,
        projectionYear: this.projectionYear,
        incomeRate: currentInvestmentInfo.incomeRate,
        growthRate: currentInvestmentInfo.growthRate,
        frankingRate: currentInvestmentInfo.frankingRate,
        contributionAmount: currentInvestmentInfo.contributionAmount,
        durationTypeId: currentInvestmentInfo.durationTypeId,
        isDRP: currentInvestmentInfo.isDRP ? 1 : 0,
        description: this.selectedInvestmentData.description,
        uniqueId: CommonHelper.uuidv4(),
        isRenewAuto: this.selectedInvestmentData.isRenewAuto,
        maturityDate: this.selectedInvestmentData.maturityDate,
        advancedetails: this.getAdvanceFilterDetails(
          this.selectedInvestmentData.advancedetails
        ),
      };
    },
    openAdvancedFilter() {
      window.dataLayer.push({ event: "cta_click_advance", user_id: 79879798 });
      this.selectedAdvanceFilterComponent = "investment-advance-filter";
      this.openTabName =
        this.openTabName == "" ? "investment-return-filter" : this.openTabName;
      this.isopenModel = true;
      this.baselineData = this.getEloquaFormModel(true);
      this.baselineData.advancedetails = this.createrowModel(
        this.selectedInvestmentData.advancedetails
      );
      this.setInvestmentChartModel(this.projectionModel);
      this.saveUserSession(InvestmentSelected, AdvaceGraphAction, "");
    },

    async applyFilter() {
      this.chartData = {
        contributionWithdrawalGraph: [],
        balanceGraph: [],
        ReturnFeesGraph: [],
      };
      if (!this.validationsProjectionYear()) {
        return false;
      }
      this.lastprojectionYear = this.projectionYear.Value;
      let baselineData = this.getEloquaFormModel(false);
      let userInput = [];
      userInput.push(baselineData);
      let apiModel = this.prepareAPIModel(userInput);
      this.setLoaderVisibility(true);
      let apiResponse = await this.getProjection(
        apiModel,
        this.selectedInvestmentData.s3FilePath
      );
      this.selectedInvestmentData.s3FilePath = "";
      this.setLoaderVisibility(false);
      this.setProjectionModel(apiResponse);
      this.isShowEmptyState = false;
      let projectionData =
        InvestmentProjection.setInvestmentProjections(apiResponse);
      if (projectionData.length == 0) {
        return;
      }
      this.projectionModel = this.setInvestmentModel(
        projectionData,
        baselineData
      );
      this.setTableElements();
      this.ResetGraphsModel();
      this.saveUserSession(InvestmentSelected, UpdateAction, "");
    },
    setTableElements() {
      if (this.getProjectionModel.investmentProjectionResult) {
        let i = 0;
        let ageResult = this.getProjectionModel.ageResults;
        let data =
          this.getProjectionModel.investmentProjectionResult[0].investmentProjection.map(
            (r) => {
              let p = r;
              p.headeryearage = ageResult
                ? ageResult[i].date +
                  "|" +
                  (ageResult[i].ageClient +
                    (ageResult[i].age_Partner
                      ? "/" + ageResult[i].age_Partner
                      : ""))
                : "";
              p.headeryearage = ageResult
                ? ageResult[i].date +
                  "|" +
                  (ageResult[i].ageClient +
                    (ageResult[i].age_Partner
                      ? "/" + ageResult[i].age_Partner
                      : ""))
                : "";
              i++;
              return p;
            }
          );
        let tableData = this.mapTableView(
          ageResult ? "headeryearage" : "year",
          tableBalanceAreaInvestment,
          data,
          ageResult ? "Year|Age" : "Year"
        );
        this.tableViewSettings = tableData;
      }
      console.log(this.tableViewSettings);
    },
    async downloadReport(flag) {
      if (flag == DownloadOption[0].value) {
        this.downloadExcelFile();
      } else if (flag == DownloadOption[1].value) {
        this.saveUserSession(InvestmentSelected, DownloadPDFFile, "");
        this.downloadPDFFile(0);
      } else {
        this.saveUserSession(InvestmentSelected, DownloadWordFile, "");
        this.downloadPDFFile(1);
      }
    },

    async downloadPDFFile(flag) {
      let cloneProjection = Object.assign({}, this.getProjectionModel);
      let investment = this.getInvestmentUIModel();
      cloneProjection.investment = investment;
      this.getPDFFileStream(
        flag,
        this.getfileName(),
        this.selectedInvestmentData.ownerId,
        JSON.stringify({
          investment: investment,
          investmentProjectionResult:
            cloneProjection.investmentProjectionResult,
        })
      );
    },

    async downloadExcelFile() {
      this.saveUserSession(InvestmentSelected, DownloadExcelFile, "");
      let fileName = this.selectedInvestmentData.description;
      let ownerInfo = this.firstOptionLabel;
      if (ownerInfo && ownerInfo.text) {
        fileName = ownerInfo.text.trim() + "_" + fileName;
      }

      this.getExcelFileStream(this.getProjectionModel, fileName);
    },
    getfileName() {
      let fileName = this.selectedInvestmentData.description;
      let ownerInfo = this.firstOptionLabel;
      if (ownerInfo && ownerInfo.text) {
        fileName = ownerInfo.text.trim() + "_" + fileName;
      }
      return fileName;
    },
    getInvestmentUIModel() {
      let formModel = Object.assign({}, this.formModel);
      let investmentData = Object.assign({}, this.selectedInvestmentData);
      let investmentUIModel = Investment.CreateInvestmentModel(
        formModel,
        investmentData
      );
      investmentData.projectionYear = this.projectionYear.Value;
      let rishProfileData = this.getRiskProfileData.data.filter(
        (sr) => sr.value == investmentData.riskProfileId
      );

      let investmentModel = this.createSaveInvestmentModel(
        investmentUIModel,
        investmentData
      );
      if (rishProfileData && rishProfileData.length > 0) {
        investmentModel.riskProfileName = rishProfileData[0].text;
      }
      return investmentModel;
    },
  },
};
</script>

<style lang="scss" module></style>
